import React from 'react';
import { Spinner } from 'components/UI';
import moment from 'moment-timezone';
import { TaxListDetailItem } from 'model/TaxListReport';
import { PriceFormat } from 'components/UI';
import styles from './TaxListDetailTable.module.scss';

export const headerNames = [
    'Invoice Number',
    'Sale Date',
    'Client Name',
    'Category',
    'Type',
    'Item',
    'Quantity',
    'Payment Method',
    'Tax Name',
    'Tax Rate',
    'Net Sales',
    'Tax on Net Sales'
];

const formatDate = (dateStr: string) => {
    if (!dateStr) return '';
    const m = moment(dateStr, ['MM/DD/YYYY', 'YYYY-MM-DD'], true);
    return m.isValid() ? m.format('MM/DD/YYYY') : dateStr;
};

const formatPercent = (value: number) => (typeof value === 'number' ? `${Number(value).toFixed(2)}%` : '');

interface TaxListDetailTableProps {
    loading: boolean;
    /** Table rows. Prefer `data`; `items` is accepted as alias for compatibility. */
    data?: TaxListDetailItem[] | null;
    /** @deprecated Use `data` instead. Kept for compatibility. */
    items?: TaxListDetailItem[] | null;
    /** @deprecated Pagination is rendered by the parent (TaxList). Ignored. */
    pagination?: { page: number; pageSize: number; totalPages: number; totalRecords: number };
    /** @deprecated Ignored. */
    changePageHandler?: (p: number) => void;
    /** @deprecated Ignored. */
    changePageSizeHandler?: (size: number) => void;
}

export const TaxListDetailTable: React.FC<TaxListDetailTableProps> = props => {
    const rows = Array.isArray(props.data) ? props.data : Array.isArray(props.items) ? props.items : [];
    const hasRows = rows.length > 0;
    const showLoading = props.loading && !hasRows;

    return (
        <div className={styles.root}>
            <div className={styles.tableWrapper}>
                <table className={styles.table}>
                    <thead>
                        <tr>
                            {headerNames.map(name => (
                                <th
                                    key={name}
                                    className={styles.headerCell}
                                >
                                    {name}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody className={styles.body}>
                        {showLoading ? (
                            <tr>
                                <td
                                    colSpan={headerNames.length}
                                    className={styles.loadingCell}
                                >
                                    <Spinner className={styles.spinner} />
                                </td>
                            </tr>
                        ) : (
                            rows.map((item, index) => (
                                <tr
                                    key={`${item.invoiceNumber}-${index}`}
                                    className={styles.row}
                                >
                                    <td className={styles.cell}>{item.invoiceNumber}</td>
                                    <td className={styles.cell}>{formatDate(item.saleDate)}</td>
                                    <td className={styles.cell}>{item.clientName}</td>
                                    <td className={styles.cell}>{item.category}</td>
                                    <td className={styles.cell}>{item.type}</td>
                                    <td className={styles.cell}>{item.item}</td>
                                    <td className={styles.cell}>
                                        {typeof item.quantity === 'number'
                                            ? item.quantity.toLocaleString()
                                            : item.quantity}
                                    </td>
                                    <td className={styles.cell}>{item.paymentMethod}</td>
                                    <td className={styles.cell}>{item.taxName}</td>
                                    <td className={styles.cell}>{formatPercent(item.taxRate)}</td>
                                    <td className={styles.cell}>
                                        <PriceFormat price={item.netSales ?? ''} />
                                    </td>
                                    <td className={styles.cell}>
                                        <PriceFormat price={item.taxOnNetSales ?? ''} />
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default TaxListDetailTable;
